const urlName = '/subsidy/v1'
export default API => ({
    // 证书列表
    getCertificateList(data,pageSize,pageNum) {
        return API({
            url: `${urlName}/certificateTemplate/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data,
        });
    },
    // 证书模板，背景列表 businessType:1背景，0是模板
    getTemplateBackGround(data){
        return API({
            url: `${urlName}/commonAttach/findList` ,
            method:  'post',
            data
        });
    },
    // 证书新增保存
    getTemplateBackSave(data){
        return API({
            url: `${urlName}/certificateTemplate/save` ,
            method:  'post',
            data,
        });
    },
    // 证书详情
    getCertificateDetail(id){
        return API({
            url: `${urlName}/certificateTemplate/findById?id=${id}` ,
            method:  'get',
        });
    },
    // 证书删除
    getCertificateDelete(id){
        return API({
            url: `${urlName}/certificateTemplate/delete?id=${id}` ,
            method:  'post',
        });
    },
    checkContent(content){
        return API({
            url: `${urlName}/certificateTemplate/checkContent?content=${content}` ,
            method:  'get',
        });
    },
    // 证书状态
    getCertificateStatus(id){
        return API({
            url: `${urlName}/certificateTemplate/getRelateList?id=${id}` ,
            method:  'get',
        });
    },
    // 查询证书列表
    getUserCertificateList(data,pageSize,pageNum) {
        return API({
            url: `${urlName}/certificate/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data,
        });
    },
    // 导出名单
    getExportCertificateList(data,pageSize,pageNum) {
        return API({
            url: `${urlName}/certificate/exportCertificateList?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data,
        });
    },
    // 导出证书
    getExportCertificateImages(data,pageSize,pageNum) {
        return API({
            url: `${urlName}/certificate/exportCertificateImages?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data,
        });
    },
})
